<template>
    <button
        @click="sendClick"
        :class="[
          { 'button-border' : hasBorder }, 
            'button-default', 
            backgroundColor,
            buttonTextColor, 
        ]"
        :disabled="disabled"
        @mouseover="isHovering = true" 
        @mouseleave="isHovering = false"
    >
        <i :class="icon" v-if="hasIcon"></i>

        <span v-if="!loading">{{ text }}</span>

        <div v-else class="button-default-loading">
            <img src="/images/loading-ummense.gif" />
        </div>
    </button>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Pressione',
        },

        textColor: {
            type: String,
            default: 'white1',
        },

        bgColor: {
            type: String,
            default: 'blue5',
        },

        hoverTextColor: {
            type: String,
            default: null,
        },

        hoverBgColor: {
            type: String,
            default: null,
        },

        hasIcon: {
            default: false,
            type: Boolean,
        },

        icon: {
            type: String,
            required: false,
        },

        hasBorder: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        loading: {
            type: Boolean,
            default: false,
        },

        type: { 
            type: String,
            default: 'regular'
        }
    },

    data() {
        return {
            isHovering: false,
        }
    },

    computed: {
        backgroundColor() {
            if (this.isHovering) {
                return this.hoverBgColor ? `bg-${this.hoverBgColor}` 
                                         : `bg-${this.bgColor} opacity-decrease`
            }

            return `bg-${this.bgColor}`
        }, 

        buttonTextColor() {
            if (this.isHovering && this.hoverTextColor) {
                return this.hoverTextColor
            }

            return this.textColor
        },

        buttonType() {
            if (this.type != 'regular' 
                && this.type != 'slim'
                && this.type != 'large'
            ) { 
                return 'regular'
            } 

            return this.type
        }
    },

    methods: {
        sendClick() {
            this.$emit('click')
        },
    },
}
</script>

<style lang="scss" scoped>
.button-default {
    cursor: pointer;
    width: 100%;
    height: 48px;
    border-radius: 4px;
    border: none;
    outline: none !important;
    padding: 10px 20px;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.slim { 
        height: 28px;
        font-size: 13px;
    }

    &.button-border {
        border: 1px solid;
    }

    &:disabled {
        background-color: $grey2;
    }

    svg {
        margin-right: 0.6rem;
    }

    .button-default-loading {
        width: 24px;
        height: 24px;

        img {
            width: 100%;
        }
    }
}

.opacity-decrease:hover {
    opacity: 0.8;
}
</style>